import { Instagram } from "lucide-react";
import { DripEdge } from "../components/DripEdge";
import { SITE } from "../data/site";

export const CtaBanner = () => (
  <section data-testid="cta-banner" aria-labelledby="cta-heading">
    <DripEdge className="text-charcoal" />
    <div className="kremes-texture-dark bg-charcoal px-5 pb-20 pt-10 text-center sm:pb-24">
      <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-bumbu-bright">
        Pesan Sekarang
      </p>
      <h2
        id="cta-heading"
        className="mx-auto mt-4 max-w-2xl font-heading text-3xl font-extrabold tracking-tight text-canvas sm:text-4xl"
      >
        Ngantre langsung atau diantar — sama-sama nikmat.
      </h2>
      <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-stone-400">
        Pesan lewat GrabFood dari outlet Wijaya, Melawai, atau mampir langsung
        ke outlet terdekatmu. Pertanyaan? Sapa kami di Instagram.
      </p>
      <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
        <a
          href={SITE.grabfood}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-grabfood-button"
          className="rounded-full bg-goang px-8 py-3.5 font-heading text-sm font-bold text-white transition-all hover:scale-[1.03] hover:bg-goang-deep active:scale-[0.98]"
        >
          Pesan via GrabFood
        </a>
        <a
          href={SITE.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-instagram-button"
          className="inline-flex items-center gap-2 rounded-full border-2 border-stone-500 px-8 py-3.5 font-heading text-sm font-bold text-canvas transition-all hover:scale-[1.03] hover:border-bumbu-bright hover:text-bumbu-bright active:scale-[0.98]"
        >
          <Instagram className="h-4 w-4" aria-hidden="true" />
          {SITE.instagramHandle}
        </a>
      </div>
    </div>
  </section>
);
